import React, { useEffect, useState } from "react"
import { View, Text, TouchableOpacity, Image, StyleSheet } from "react-native"
import { store } from "../../store/store";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import AppTheme from "../../AppTheme";
import * as CommonUtils from "../../utils/services/CommonUtils"
import AppStyles from "../../AppStyles";
import { MaterialIcons } from '@expo/vector-icons';
import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import TextStyle from "../../TextStyle";

const FirstConsultation = (props) => {

    const [consultList, updateConsultList] = useState([]);


    useEffect(() => {
        const reduxState = store.getState();
        if (reduxState.consultationList) {
            var list: any = [];
            list = reduxState.consultationList;
            updateConsultList(list)
        }
    }, [])

    return <View style={{ flex: 1, width: AppTheme.appWidth }}>
        <View style={{ position: 'fixed', zIndex: 10, backgroundColor: 'white', width: AppTheme.appWidth }}>
            <CommonHeader navigation={props.navigation} title='E-Consult'></CommonHeader>
        </View>
        <Image resizeMode={'stretch'} style={{ marginTop: 56 }} source={{
            uri: CommonUtils.getImagePath('/images/consultation/econsult_doctor_image.png'),
            width: AppTheme.appWidth, height: AppTheme.appWidth * 0.8
        }} />
        <View style={[styles.firstConsultView, { backgroundColor: AppTheme.color.white }]}>
            <Text style={[styles.talkToLbl, { marginHorizontal: 16, marginTop: 17 }]}>Talk to Doctors</Text>
            <Text style={styles.no_appointments}>No appoinment required</Text>
            <Text style={styles.hr_line}></Text>
            <Text style={[styles.no_appointments, { marginTop: 12, color: AppTheme.color.grey.text }]}>TEAM OF
                <Text style={{ color: AppTheme.color.primary }}>5000+ </Text>EXPERT DOCTORS</Text>
            <TouchableOpacity onPress={() => {
                props.navigation.navigate(ScreenRoute.member_selection);
            }}>
                <View style={styles.startConsultBtn}>
                    <View style={{ flex: 1, justifyContent: 'space-between', flexDirection: 'row', }}> <Text style={[TextStyle.text16, { color: AppTheme.color.white }]}>
                        Start a new consultation</Text>
                        <MaterialIcons style={{ fontSize: 18, position: 'relative', top: 2, paddingLeft: 20, color: AppTheme.color.white }} name="arrow-forward-ios" /></View>
                </View>
            </TouchableOpacity>

            <Text style={[AppStyles.f16, { color: AppTheme.color.black, marginHorizontal: 23, marginVertical: 16 }]}>How consultation happens?</Text>
            <View>
                <Image resizeMode={'stretch'} source={{
                    uri: CommonUtils.getImagePath('/images/how_econsult_happen/how_consultation.svg'),
                    width: AppTheme.appWidth - 32, height: AppTheme.appWidth * 0.35
                }} style={{ marginLeft: 16 }} />
            </View>
            {/* <View style={{ marginHorizontal: 32, flex: 1, marginBottom: 30, flexDirection: 'row', justifyContent: "space-between", alignItems: 'center' }}>
                <View style={{ width: 72, alignItems: 'center' }}>
                    <Image source={{
                        uri: CommonUtils.getImagePath('/images/how_econsult_happen/share_problem.svg'),
                        width: 25, height: 19
                    }} height={140} />
                    <Text style={[AppStyles.f12, { textAlign: 'center', paddingTop: 12, color: AppTheme.color.black }]}>Share your problem</Text>
                </View>
                <Text style={{ top: 5, position: 'relative', color: '#e0e0e0' }}> ----- <MaterialIcons style={{ top: -16, left: -10, fontSize: 18, position: 'relative', paddingLeft: 20, color: '#e0e0e0' }} name="arrow-forward-ios" /></Text>
                <View style={{ width: 72, alignItems: 'center' }}>
                    <Image source={{
                        uri: CommonUtils.getImagePath('/images/how_econsult_happen/doctor_call.svg'),
                        width: 25, height: 19
                    }} height={140} />
                    <Text style={[AppStyles.f12, { textAlign: 'center', paddingTop: 12, color: AppTheme.color.black }]}>Share your problem</Text>
                </View>
                <Text style={{ top: 5, position: 'relative', color: '#e0e0e0' }}> ----- <MaterialIcons style={{ top: -16, left: -10, fontSize: 18, position: 'relative', paddingLeft: 20, color: '#e0e0e0' }} name="arrow-forward-ios" /></Text>
                <View style={{ width: 72, alignItems: 'center' }}>
                    <Image source={{
                        uri: CommonUtils.getImagePath('/images/how_econsult_happen/get_prescription.svg'),
                        width: 25, height: 19
                    }} height={140} />
                    <Text style={[AppStyles.f12, AppStyles.applyFont, { textAlign: 'center', paddingTop: 12, color: AppTheme.color.black }]}>Share your problem</Text>
                </View>

            </View> */}
        </View>
    </View >
}

export default FirstConsultation;

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    firstConsultView: {
        position: 'relative',
        top: -4,
        // shadowRadius: 1,
        shadowOpacity: 16,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        background: AppTheme.color.white,
        borderTopWidth: 1,
        zIndex: 100,
        borderColor: AppTheme.color.lightGreyColor
    },
    startConsultBtn: {
        paddingHorizontal: 24, paddingVertical: 31, marginTop: 18, marginBottom: 25, borderRadius: 4,
        backgroundColor: AppTheme.color.primary, marginHorizontal: 16, shadowRadius: 2, shadowOpacity: 2, shadowColor: AppTheme.color.lightGreyColor
    },
    aayuCard_benefits: {
        marginHorizontal: 24,
    },
    aayuCard_benefits_image: {
        marginBottom: 16,
    },
    aayuCard_benefits_text: {
        marginBottom: 16,
    },
    talkToLbl: {
        fontSize: 30,
        color: '#0a0a0a'
    },
    no_appointments: {
        color: AppTheme.color.primary,
        fontSize: 16,
        marginHorizontal: 16
    },
}))
